import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { timeParse } from "d3-time-format";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.tz.setDefault("America/New_York");

const API_KEY = "psaf1Tgp8PYTaocSBe4QnhgFHXVZE2uK";
const INTERVAL = "minute"; // Replace with your desired interval
const DATE_RANGE = "30"; // Number of days

const parseData = (data) => {
  return data.map((d) => {
    const date = dayjs(d.timestamp).utc().tz("America/New_York").toDate();
    return {
      ...d,
      date: new Date(date), // Convert string to Date object
      open: d.open,
      high: d.high,
      low: d.low,
      close: d.close,
      volume: d.volume,
    };
  });
};

const useInterval = (callback, delay) => {
  const intervalRef = useRef(null);
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === "number") {
      intervalRef.current = window.setInterval(tick, delay);
      return () => window.clearInterval(intervalRef.current);
    }
  }, [delay]);

  return intervalRef;
};

export function useMarketData(dataSet = "INTRADAY", updating = false, trades) {
  const [data, setData] = useState();
  const [length, setLength] = useState(500);
  const SYMBOL = trades?.symbol.toUpperCase();
  const openDate = trades?.openDate.toString(); // "20250811152542"
  const startDate = openDate
    ? (() => {
        let date = dayjs(`${openDate.slice(0, 8)}`, "YYYYMMDD").subtract(
          15,
          "day"
        );

        return date.format("YYYY-MM-DD");
      })()
    : null;

  const endDate = dayjs().format("YYYY-MM-DD"); // always today

  useEffect(() => {
    const fetchData = async () => {
      // const end = new Date();
      // const start = new Date();
      // start.setDate(start.getDate() - DATE_RANGE);

      const url = `https://api.polygon.io/v2/aggs/ticker/${SYMBOL}/range/1/${INTERVAL}/${startDate}/${endDate}?adjusted=true&sort=desc&limit=50000&apiKey=${API_KEY}`;
      const response = await axios.get(url);
      const result = response.data;

      const formattedData = result.results.map((item) => ({
        timestamp: item.t,
        open: item.o,
        high: item.h,
        low: item.l,
        close: item.c,
        volume: item.v,
      }));

      const parsedData = parseData(formattedData);
      // Sort the data in ascending order by date
      const sortedData = parsedData.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );

      setData(sortedData);
    };

    if (!data && SYMBOL) {
      fetchData();
    }
  }, [data, SYMBOL, startDate, endDate]);

  useInterval(() => {
    if (data && updating) setLength(length + 1);
  }, 1000);

  return {
    data: updating ? data?.slice(0, length + 1) : data,
    loaded: Boolean(data),
  };
}
